import TradingPreferencesContainer from "./TradingPreferences.container";
export default TradingPreferencesContainer;